import React from 'react'
import './seperator.css';
function Seperator() {
  return (
    <div className='seperator'></div>
  )
}

export default Seperator